
import { Vue, Component, InjectReactive, Prop } from "vue-property-decorator";
import { USER_SYMBOL } from "../../constants";
import { AuthUserEntity } from "../../entities/user.entity";
import { IBattleUser } from "../../interfaces/battle.interface";
import { BattleUserEntityFragment } from "../../graphql/fragments";
import gql from "graphql-tag";
import Price from "@/components/base/Price.vue";

@Component({
  components: {
    Price,
  },
  apollo: {
    user: {
      query: gql`
        query ($_id: ID!) {
          findOneBattleUser(_id: $_id) {
            ...BattleUserEntity
          }
        }
        ${BattleUserEntityFragment}
      `,
      variables() {
        return { _id: this.userId };
      },
      skip() {
        return !!this.user || !this.userId;
      },
      update(data) {
        return data.findOneBattleUser;
      },
    },
  },
})
export default class BattleUserSum extends Vue {
  @InjectReactive(USER_SYMBOL) selfUser!: AuthUserEntity | null;
  @Prop() userId!: string | null;
  @Prop() color!: string;
  @Prop() price!: number | null;
  @Prop({ type: Boolean, default: false }) loser!: boolean;
  @Prop({ type: Boolean, default: false }) winner!: boolean;
  @Prop({ type: Boolean, default: false }) animated!: boolean;
  @Prop() battlePrice!: number;
  @Prop({ type: Boolean, default: false }) joinDisabled!: boolean;

  private user: IBattleUser | null =
    this.selfUser && this.selfUser._id === this.userId
      ? this.selfUser
      : this.userId
      ? this.$apollo.provider.defaultClient.readFragment({
          id: "BattleUserEntity:" + this.userId,
          fragment: BattleUserEntityFragment,
        })
      : null;
}
